import { Autocomplete, Checkbox, Grid, TextField } from '@mui/material';
import useRoles from '../hooks/useRoles';
import { getComboBoxOptions } from '../utils/Utils';
import { ComboBoxOption } from './form/controls/ComboBox';
import { storeRoleSelections } from './form/react-hook-form-components/FilterStorage';
import { IFilterOptions } from '../pages/FilterOptions';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Chip from '@mui/material/Chip';

interface IFilterOptionsProps {
  team: ComboBoxOption | null;
  roles: ComboBoxOption[];
  proxy: boolean | undefined;
}

interface IFilterProps {
  state: IFilterOptionsProps;
  setState: React.Dispatch<React.SetStateAction<IFilterOptions>>;
  page: string;
}

function Filters(props: IFilterProps) {
  const { data: roleList } = useRoles();
  const { setState, state, page } = props;
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const getRoleList = (): ComboBoxOption[] => getComboBoxOptions(roleList);

  const handleChange = (roles: ComboBoxOption[]) => {
    setState({
      ...state,
      roles,
    });
    storeRoleSelections(page!, roles);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Autocomplete
          disableCloseOnSelect
          multiple={true}
          onChange={(_, newValue: ComboBoxOption[]) => {
            handleChange(newValue);
          }}
          value={state.roles ?? []}
          limitTags={2}
          options={getRoleList()}
          getOptionLabel={option => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
              {option.label}
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => <Chip label={option.label} size="small" {...getTagProps({ index })} />)
          }
          renderInput={params => <TextField {...params} label="Roles" />}
        />
      </Grid>
    </Grid>
  );
}

export default Filters;
